<template>
  <div class="home-page container">
    <div class="left">
      <p>
        Prepare for upcoming UTME, Post-UTME exmination with all the past
        questions at your finger tips
      </p>
      <h3>Past Questions availbale for CMP, CPB and others</h3>
      <p>
        One time payment for all the courses.
        <br />
        <small>*T & C apply</small>
      </p>
      <div>
        <a href="" role="button">
          Buy now
        </a>
      </div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>
